import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"
import { IPreassignationsParam } from "../preassignations/types"
import { IAssignation } from "./types"
import api from "services/api"

export function useAssignations(
  params?: IPreassignationsParam,
  config?: UseQueryOptions<IAssignation[]>
) {
  return useQuery<IAssignation[]>(["suite", "time", "assignations", params], {
    keepPreviousData: true,
    ...config,
  })
}

export function useAssignationsCalendar(config?: UseMutationOptions<any>) {
  return useMutation<any>(
    async () => {
      const response = await api.get(
        `suite/time/assignations/generate-calendar`,
        {
          responseType: "blob",
        }
      )

      const disposition = response.headers["content-disposition"]
      let filename = "Assignations.ical"
      if (disposition && disposition.includes("attachment")) {
        const filenameMatch = disposition.match(/filename="(.+)"/)
        if (filenameMatch?.length === 2) {
          filename = filenameMatch[1]
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    {
      ...config,
    }
  )
}

export function useSubstitueAssignation(
  config?: UseMutationOptions<
    unknown,
    unknown,
    { assignationId: string; comment?: string }
  >
) {
  const queryClient = useQueryClient()
  return useMutation(
    ({ assignationId, ...data }) =>
      api.post(
        `suite/time/assignations/substitutions/${assignationId}/substitute`,
        data
      ),
    {
      ...config,
      onSuccess(data, vars, conext) {
        config?.onSuccess?.(data, vars, conext)
        queryClient.setQueryData<IAssignation[]>(
          ["suite", "time", "assignations", null],
          (queryData) =>
            queryData?.map((el) =>
              el.id === vars.assignationId
                ? { ...el, has_substitution: true }
                : el
            )
        )
        queryClient.invalidateQueries(["suite", "time", "assignations"])
      },
    }
  )
}
